// removed by extract-text-webpack-plugin
module.exports = {"mazeStaticStageWrapper":"MazeStatic-cssmodule-mazeStaticStageWrapper-3NnD1","mazeStatic":"MazeStatic-cssmodule-mazeStatic-2tUsO"};


//////////////////
// WEBPACK FOOTER
// ./components/MazeSet/MazeStatic.cssmodule.less
// module id = 646
// module chunks = 0